import { ReactElement, useCallback } from 'react';
import { base64ToJson, exportCSVFile } from './helpers';

export type AllieReportDownloaderQuery = () => Promise<{
  data: Record<string, { base64: string }>;
  fileName?: string;
}>;

export interface AllieReportDownloaderProps {
  query: AllieReportDownloaderQuery;
  render: ({ onClick }: { onClick: () => Promise<void> }) => ReactElement;
  title: string;
}

export const AllieReportDownloader = ({ query, title, render }: AllieReportDownloaderProps) => {
  const downloadCSV = useCallback(async () => {
    const { data, fileName } = await query();
    const base64Data = base64ToJson(data[Object.keys(data)[0]].base64);
    const headers = Object.keys(base64Data[0]).reduce((acum, k) => ({ ...acum, [k]: k }), {});
    const formattedData: Record<string, unknown>[] = [];

    // remove commas to avoid errors
    base64Data.forEach((item: any) => {
      formattedData.push({
        ...item,
      });
    });
    exportCSVFile(headers, formattedData, fileName || title);
  }, [query]);

  return render({ onClick: downloadCSV });
};
